import React from 'react';

import Community     from './community';
import YourInventory from './your-inventory';
import P4f           from './p4f';
import FooterImage   from '../footer-image';

export default function Page4() {
    return (
        <>
            <YourInventory />
            <Community />
            <P4f />
            <FooterImage />
        </>
    );
}
